import script from "./NoteIdPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteIdPage.vue?vue&type=script&setup=true&lang=js"

import "./NoteIdPage.vue?vue&type=style&index=0&id=0d522fd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d522fd2"]])

export default __exports__